import { Api } from "./Api";
import { Subscription } from "./types";

export const SubscriptionApi = {
  async getSubscriptionData() {
    try {
      const { data: response } = await Api.get<{ payload?: Subscription }>(
        `/subscriptions/get-subscription-data`
      );
      return response.payload ?? null;
    } catch (error) {
      console.log(error);
    }
  },
};
